<div class="dialog-wrappers">
  <div class="display-flex padding-dialog dialog-header">
    <div class="float-left">
      <div class="dialog-header-title">        
        <h1>Reset Prompt</h1>
      </div>      
    </div>
    <div class="float-right">
      <span class="close-dialog" mat-dialog-close><img src="../../../assets/icons/icon-close-red.png" alt="Close" width="20" /></span>
     </div>
   </div>
  <mat-dialog-content>
    <div class="padding-dialog">
      <p>Are you sure,  you want to reset?</p>
      <p>It will reset the promt to system default.</p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close class="btn-white btn-dialog-cancel">Cancel</button>
    <button mat-button (click)="confirmReset()" class="btn-red">Reset</button>
  </mat-dialog-actions>
  </div>